import { render, staticRenderFns } from "./sys-user-add-or-update.vue?vue&type=template&id=35579f47&scoped=true&"
import script from "./sys-user-add-or-update.vue?vue&type=script&lang=js&"
export * from "./sys-user-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./sys-user-add-or-update.vue?vue&type=style&index=0&id=35579f47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35579f47",
  null
  
)

export default component.exports